import { render, staticRenderFns } from "./BoAddUser.vue?vue&type=template&id=80534c90&"
import script from "./BoAddUser.vue?vue&type=script&lang=js&"
export * from "./BoAddUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports